<ng-content></ng-content>
<div
  class="overlay"
  *ngIf="tooltipText.length"
  [matTooltip]="tooltipText"
></div>
